/**
 * Смотри: https://en.wikipedia.org/wiki/Opaque_data_type
 * В нашем случае запрещает создание типов напрямую
 */
export type Opaque<T, U> = T & { readonly _TAG_: U };

export function runFloatingAsyncAction(action: () => Promise<void>): void {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    action();
}

export type ValueOf<T> = T[keyof T];
